import { render, staticRenderFns } from "./competition-recom.vue?vue&type=template&id=6fa230df&scoped=true&"
import script from "./competition-recom.vue?vue&type=script&lang=js&"
export * from "./competition-recom.vue?vue&type=script&lang=js&"
import style0 from "./competition-recom.vue?vue&type=style&index=0&id=6fa230df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa230df",
  null
  
)

export default component.exports